export default __webpack_public_path__ + "img/list3.28275d6f.jpg";